module.exports = __webpack_public_path__ + "img/png.e2675477.png";